<template>
  <div id="users-list">
    <SidebarLayout2 :breadcrumb="breadcrumb" pageTitle="Listagem de No-Show">
      <!-- SIDEBAR -->
      <template #sidebar>
        <SidebarBlock class="page-actions">
          <Heading class="page-actions--title">
            Ações da página
          </Heading>

          <!-- BOTÃO CADASTRAR -->
          <PmwButton
            :disabled="selectedRows.length !== 1"
            :hasIcon="true"
            id="create"
            variation="pmw-primary"
            class="page-actions--button"
            @click.stop.prevent="openNoShow(selectedRows[0])"
          >
            Cobrar No-Show
          </PmwButton>

          <!-- BOTÃO EDITAR -->
          <PmwButton
            :disabled="selectedRows.length !== 1"
            :link="`detalhes-de-reservas/${selectedRows[0]?.reserva}`"
            element="router-link"
            variation="pmw-primary"
            class="page-actions--button"
            target="_blank"
          >
            Visualizar Reserva
          </PmwButton>
        </SidebarBlock>
      </template>

      <!-- CONTEÚDO -->
      <template #content>
        <div class="filters">
          <PmwFilterCombinated
            :filters="selectedFilters"
            :fixedFilters="fixedFilters"
            :options="filterOptions"
            ref="pmwFilterCombinated"
            class="filters--filter-combinated"
            @filter="getFilters()"
          />
        </div>

        <!-- TABELA -->
        <DataTable
          :cols="cols"
          :colsMinWidths="colsMinWidths"
          :sortable="true"
          :isLoading="isLoading"
          :rows="allData"
          :selectableRow="true"
          ref="dataTable"
          maxHeight="1080"
          class="datatable"
          @getSelectedRows="selectedRows = $event"
        >
          <template v-slot:reserva="data">
            {{ data.rowDataObj.reserva }}
          </template>
          <template v-slot:checkin="data">
            {{ data.rowDataObj.checkin }}
          </template>
          <template v-slot:status="data">
            {{ data.rowDataObj.status }}
          </template>
          <template v-slot:valorReal="data">
            {{
              converToCurrency(
                data.rowDataObj.valorPrimeiraDiaria.valor,
                0,
                data.rowDataObj.valorPrimeiraDiaria.moeda
              )
            }}
          </template>

          <template v-slot:valorTotal="data">
            {{
              converToCurrency(
                data.rowDataObj.valorTotal.valor,
                0,
                data.rowDataObj.valorTotal.moeda
              )
            }}
          </template>

          <template v-slot:editar="data">
            <button
              class="links edit"
              @click.stop.prevent="openNoShow(data.rowDataObj)"
            >
              Cobrar No-Show
            </button>
          </template>
        </DataTable>
        <!-- PAGINAÇÃO -->
        <PmwPagination
          :itemsPerPage="pagination.itemsPerPage"
          :currentPage="pagination.currentPage"
          :totalItems="pagination.totalItems"
          :itemsPerPageOptions="pagination.itemsPerPageOptions"
          @changePagination="changePagination"
        />

        <ChargeModal
          v-model="showModal"
          :singleData="singleData"
          :btnDisable="btnDisable"
          @cancel="modalCancel"
          @confirm="chargeNoShow(singleData.reserva)"
        />
      </template>
    </SidebarLayout2>
  </div>
</template>

<script>
/** Componentes */

/** Biblioteca */
import PmwButton from '@solucoes/components-lib-tmp/src/components/elements/PmwButton'
import DataTable from '@solucoes/components-lib-tmp/src/components/patterns/DataTable'
import Heading from '@solucoes/components-lib-tmp/src/components/elements/Heading'
import PmwPagination from '@solucoes/components-lib-tmp/src/components/patterns/PmwPagination'
import PmwFilterCombinated from '@solucoes/components-lib-tmp/src/components/patterns/PmwFilterCombinated'
import SidebarBlock from '@solucoes/components-lib-tmp/src/components/patterns/SidebarBlock'

/** Locais */
import { formatDate } from '@/helpers/date'
import { converToCurrency } from '@/helpers/math'
import SidebarLayout2 from '@/layouts/SidebarLayout2'
import ChargeModal from '@/components/hotel/noShow/ChargeModal'

export default {
  name: 'NoShowList',
  components: {
    PmwButton,
    DataTable,
    Heading,
    PmwPagination,
    SidebarLayout2,
    PmwFilterCombinated,
    SidebarBlock,
    ChargeModal
  },
  data() {
    return {
      breadcrumb: [
        {
          label: 'Letsbook',
          url: '',
          isSpa: false /** se deve ser um link para o site novo ou antigo  */
        },
        {
          label: 'No-Show',
          url: '',
          isSpa: false /** se deve ser um link para o site novo ou antigo  */
        }
      ],

      /** Desabita botão de cobrança no modal */
      btnDisable: false,

      /** Filtros selecionados */
      selectedFilters: [],

      /** Dados apenas da reservas selecionada.  */
      singleData: null,

      /** Valores dos itens do filtro */
      filterValues: {
        hospede: null,
        hotel: null,
        statusReserva: null,
        codigoReserva: null,
        dataChegada: null
      },

      fixedFilters: [
        {
          options: ['chegada', 'codigoReserva', 'hospede']
        }
      ],

      /** Dados de filtro */
      filterOptions: [
        {
          text: 'Dia da chegada',
          type: 'date',
          name: 'chegada',
          placeholder: '00/00/0000',
          value: new Date()
        },
        {
          text: 'Código da Reserva',
          type: 'search',
          name: 'codigoReserva',
          placeholder: 'Digite o código',
          value: null
        },
        {
          text: 'Hóspede',
          type: 'search',
          name: 'hospede',
          placeholder: 'Digite o nome ou email',
          value: null
        },
        {
          text: 'Hotéis',
          type: 'select_with_search',
          name: 'hotel',
          placeholder: 'Selecione o hotel',
          description: 'Selecione',
          search: true,
          options: []
        },

        {
          text: 'Status reserva',
          type: 'select',
          name: 'statusReserva',
          description: 'Selecione',
          options: [
            { text: 'Confirmada', value: 0 },
            { text: 'Cancelada ', value: 1 }
          ],
          value: { text: 'Confirmada', value: 0 }
        }
      ],

      /** Colunas da tabela */
      cols: [
        {
          alias: 'Reserva',
          name: 'reserva'
        },
        {
          alias: 'Data Chegada',
          name: 'checkin'
        },
        {
          alias: 'Hóspede Reservante',
          name: 'hospedeReservante'
        },
        {
          alias: 'Status Reserva',
          name: 'status'
        },
        {
          alias: 'Valor 1º Diária',
          name: 'valorReal'
        },
        {
          alias: 'Valor Total',
          name: 'valorTotal'
        },
        {
          alias: 'Ações',
          name: 'editar'
        }
      ],
      /** Largura mínima das colunas */
      colsMinWidths: {
        reserva: '90px',
        checkin: '120px',
        hospedeReservante: '200px',
        status: '135px',
        valorReal: '125px',
        valorTotal: '100px',
        editar: '125px'
      },

      /** V-model da busca */
      filterByName: '',

      /** Dados da paginação */
      pagination: {
        totalItems: 0,
        currentPage: 1,
        itemsPerPage: 10,
        startItemIndex: 1,
        lastItemIndex: 10,
        itemsPerPageOptions: [
          {
            text: '10',
            value: 10
          },
          {
            text: '25',
            value: 25
          },
          {
            text: '50',
            value: 50
          },
          {
            text: '75',
            value: 75
          }
        ]
      },

      /** Linhas da tabela (dados) */
      rows: [],

      /** Armazena dados de retorno */
      allData: [],

      /** Loading da tabela */
      isLoading: false,

      /** Array das linhas selecionadas */
      selectedRows: [],

      /** Exibição da modal de deleção */
      showModal: false
    }
  },

  created() {
    /** Chamada dos dados dos hoteis */
    this.getHotels()
  },

  mounted() {
    this.selectedFilters = [...this.selectedFilters]

    /** Fecha o filtro */
    this.$refs['pmwFilterCombinated'].filter()
  },

  methods: {
    converToCurrency: converToCurrency,

    modalCancel() {
      this.singleData = null
      this.showModal = false
    },

    /** Item utilizado para retorno de dados dos filtros selecionados */
    getFilters() {
      /** Pegar o filtro de número da Reserva */
      this.filterValues.codigoReserva = this.selectedFilters.find(
        (item) => item.name === 'codigoReserva'
      )?.value

      /** Pegar o filtro de status Reserva */
      this.filterValues.statusReserva = this.selectedFilters.find(
        (item) => item.name === 'statusReserva'
      )?.value.value

      /** Caso não tenha filtro de status, é pesquisado apenas os ativos */
      this.filterValues.statusReserva === undefined || null
        ? (this.statusReserva = 0)
        : null

      /** Pegar o filtro de hospede */
      this.filterValues.hospede = this.selectedFilters.find(
        (item) => item.name === 'hospede'
      )?.value

      /** Pega o filtro de hotel */
      this.filterValues.hotel = this.selectedFilters.find(
        (item) => item.name === 'hotel'
      )?.option.value

      const selectedFilter = this.selectedFilters.find(
        (item) => item.name === 'chegada'
      )
      if (selectedFilter && selectedFilter.value === null) {
        selectedFilter.value = new Date()
      }

      /** Pega o filtro de hospedagem final */
      this.filterValues.dataChegada = this.selectedFilters.find(
        (item) => item.name === 'chegada'
      )?.value

      if (this.filterValues.dataChegada) {
        /** Ajusta padrão de data */
        this.filterValues.dataChegada = `${formatDate(
          new Date(this.filterValues.dataChegada),
          'yyyy-MM-dd'
        )}T00:00:00`
      }

      /** Chamada dos dados da listagem */
      this.getNoShow()
    },

    /** Retorna dados da listagem
     * @param {Number} page - Página da pesquisa (inicia em 1)
     */
    async getNoShow(page = 1) {
      /** Ativa loading da tabela */
      this.changeLoadingState()

      /** Atualizar a página da pesquisa */
      this.pagination.currentPage = page

      /** Limpa todos os itens selecionados */
      this.selectedRows = []

      /** Configura os dados dos filtros */
      const filters = {}
      filters.codigoReserva = this.filterValues.codigoReserva
      filters.statusReserva = this.filterValues.statusReserva
      filters.hospede = this.filterValues.hospede
      filters.hotel = this.filterValues.hotel
      filters.dataChegada = this.filterValues.dataChegada
      /** Adicionar filtros de paginação */
      filters.pagina = this.pagination.currentPage
      filters.tamanhoPagina = this.pagination.itemsPerPage

      if (!filters.dataChegada && !filters.codigoReserva && !filters.hospede) {
        await this.changeLoadingState()

        this.$bus.$emit('show-alert-chip', {
          message: 'É necessário o preenchimento do filtro obrigatório'
        })

        /** Abri o filtro para edição */
        return this.$refs['pmwFilterCombinated'].hideFilters()
      }

      this.$noShow.getNoShow(filters).then((response) => {
        const results = response.data.itens

        /** Atualizar paginação */
        this.pagination.totalItems = response.data.paginacao.totalItens
        this.pagination.currentPage = response.data.paginacao.paginaAtual
        this.pagination.itemsPerPage = response.data.paginacao.tamanhoPagina

        /** Mapeamento dos dados utilizados na listagem */
        results.forEach(function(key, index) {
          results[index]['data'] = {
            /** Dados */
            reserva: key.reserva,
            dataReserva: formatDate(new Date(key.dataReserva)),
            codigoPMS: key.codigoPMS,
            hotel: key.hotel,
            hospedeReservante: key.hospedeReservante,
            checkin: formatDate(new Date(key.checkin)),
            checkout: formatDate(new Date(key.checkout)),
            status: key.status,
            statusPagamento: key.statusPagamento,
            temExtras: key.temExtras,
            modalidadeCobranca: key.modalidadeCobranca,
            valorPrimeiraDiaria: key.valorPrimeiraDiaria,
            valorReal: key.valorPrimeiraDiaria.valor,
            valorTaxasPrimeiraDiaria: key.valorTaxasPrimeiraDiaria,
            valorTotal: key.valorTotal
          }
        })

        this.allData = results
      })
      this.changeLoadingState()
    },

    changeLoadingState() {
      this.isLoading = !this.isLoading
    },

    /** Buscar os hotéis */
    getHotels() {
      this.$reservation
        .getHotels()
        .then((response) => {
          const results = response.data.map((item) => {
            item.text = item.nome
            item.value = item.codigo
            return item
          })

          /** Adiciona opções de seleção para o filtro de hoteis */
          this.filterOptions = this.filterOptions.map((option) => {
            if (option.name === 'hotel') {
              option.options.push(...results)
            }
            return option
          })
        })
        .catch(function() {
          this.$bus.$emit('show-alert-chip', {
            message: 'Houve um erro ao buscar as opções de hotéis.'
          })
        })
    },

    /** Realiza a cobrança do no-show
     *  @param {Integer} codigo - Código da reserva
     */
    async chargeNoShow(codigo) {
      this.isLoading = false
      this.btnDisable = true

      await this.$noShow
        .chargeNoShow({ codigoReserva: codigo })
        .then(() => {
          this.$bus.$emit('show-alert-chip', {
            message: 'No-Show cobrado com sucesso.'
          })

          /** Chamada dos dados da listagem */
          this.getNoShow()
        })
        .catch((error) => {
          this.$bus.$emit('show-alert-chip', {
            message: error.response.data[0].message
          })
        })

      this.singleData = null
      this.showModal = false
      this.btnDisable = false
    },

    /** Utilizado para abrir os dados de cobrança do no-show
     * @param {Array} data Dados da reserva selecionada
     */
    openNoShow(data) {
      this.showModal = true
      this.singleData = data
    },

    /** Usado para controle da paginação */
    changePagination(childData) {
      this.pagination.currentPage = childData.currentPage
      this.pagination.perPage = childData.perPage
      /** Realizar consulta novamente */
      this.getNoShow(childData.currentPage)
    }
  }
}
</script>

<style lang="scss" scoped>
.sidebar {
  &-buttons {
    display: flex;
    flex-direction: column;
    width: 215px;
    gap: 10px;
    margin: auto;
  }
}

.filters {
  margin: 10px 0px 35px 0px;
}

.links {
  border: none;
  background-color: inherit;
  &.edit {
    font-weight: font-weight('weight-medium');
    color: pmw-colors('blue-100');
  }
  &.delete {
    color: pmw-colors('error-100');
  }
  &.disabled {
    color: pmw-colors(grey-70);
    pointer-events: none;
  }
}

.datatable {
  ::v-deep {
    .pmw-col.pmw-th:nth-child(8) {
      pointer-events: none;
      border-right: none;
      .pmw-sort-icons {
        display: none;
      }
    }
    /** Largura - Reservas */
    .pmw-col.pmw-th:nth-child(8),
    .pmw-col.pmw-td:nth-child(8) {
      max-width: 125px;
    }
  }
  .action {
    &--item {
      font-size: font-size('size-small');
    }
  }
}

.page-actions {
  padding-top: 35px;
  &--button {
    width: 100%;
    cursor: pointer;

    & + .page-actions--button {
      margin-top: 10px;
    }
  }
  &--tip-text {
    color: $pmw-gray-darkest;
    font-size: 14px;
    line-height: 21px;
    max-width: 215px;
  }
}

::v-deep {
  .lb-breadcrumb--link:nth-child(2) {
    cursor: default;
    pointer-events: none;
  }

  .content {
    /** Padding abaixo do título da página */
    .page-heading {
      padding-bottom: 24px;
    }
  }

  .datable-grid-wrapper {
    .col {
      padding-left: 14px;
    }
  }
}
</style>
